import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutCarrierSelectionExpand extends Layout {
	sourceRevenueDetail: DataSource;
	tableCharges: Table;
}
